import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

const KEY = 'fixnow:remembered-login-email';

async function ensureNativePrefsReady(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  const deadline = Date.now() + 4000;
  while (Date.now() < deadline) {
    try {
      await Preferences.get({ key: KEY });
      return;
    } catch {
      await new Promise((r) => setTimeout(r, 40));
    }
  }
}

async function getStored(): Promise<string | null> {
  if (Capacitor.isNativePlatform()) {
    await ensureNativePrefsReady();
    const { value } = await Preferences.get({ key: KEY });
    return value ?? null;
  }
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

async function setStored(email: string): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    await ensureNativePrefsReady();
    await Preferences.set({ key: KEY, value: email });
    return;
  }
  try {
    localStorage.setItem(KEY, email);
  } catch {
    /* ignore */
  }
}

async function clearStored(): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    await Preferences.remove({ key: KEY });
  }
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

/** 讀取上次成功登入的 email（不含密碼） */
export async function getRememberedEmail(): Promise<string> {
  const value = await getStored();
  return (value || '').trim();
}

/** 登入成功後記住 email */
export async function saveRememberedEmail(email: string): Promise<void> {
  const trimmed = email.trim().toLowerCase();
  if (!trimmed || !trimmed.includes('@')) return;
  await setStored(trimmed);
}

/** 登出時可選擇清除（預設保留方便下次預填） */
export async function clearRememberedEmail(): Promise<void> {
  await clearStored();
}
